import { useLocation } from 'react-router-dom';

import { PAGINATION_ROWS_PER_PAGE } from '../constants/constants';
import {
  SortingDirection,
  SortingOffersValue,
  SortingOrderValue
} from '../constants/enums';
import { decodeUrlArrayParam } from '../utils/queryParamsUtil';

type SortingType = 'offers' | 'orders' | '';

export function usePaginationFromURL<T extends SortingType>(type: T) {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const page = Number(queryParams.get('page') || 0);
  const rows = Number(queryParams.get('rows') || PAGINATION_ROWS_PER_PAGE);

  type SortValue = T extends 'offers' ? SortingOffersValue : SortingOrderValue;
  let sortValue: SortValue, direction: SortingDirection;

  if (type === 'offers') {
    sortValue = ((queryParams.get('sortValue') as SortingOffersValue) ||
      SortingOffersValue.CREATED_AT) as SortValue;
  } else {
    sortValue = ((queryParams.get('sortValue') as SortingOrderValue) ||
      SortingOrderValue.DATE) as SortValue;
  }

  direction =
    (queryParams.get('direction') as SortingDirection) || SortingDirection.DESC;

  const statuses: string[] = decodeUrlArrayParam(queryParams.get('statuses'));

  const publisherPurchaseId = queryParams.get('publisherPurchaseId') || '';

  const playerId = queryParams.get('playerId') || '';

  const orderId = queryParams.get('orderId') || '';

  const subscriptionId = queryParams.get('subscriptionId') || undefined;

  const receiptId = queryParams.get('receiptId') || '';

  const projects = queryParams.get('projects')?.split(',') || [];

  const transactionId = queryParams.get('transactionId') || '';

  const startDate = queryParams.get('startDate') || '';

  const endDate = queryParams.get('endDate') || '';

  const isFree = queryParams.get('isFree') || '';

  const playerEmail = queryParams.get('playerEmail') || '';

  const search = queryParams.get('search') || '';

  const offerStatuses: string[] = decodeUrlArrayParam(
    queryParams.get('offerStatuses')
  );

  const offerSchedules: string[] = decodeUrlArrayParam(
    queryParams.get('offerSchedules')
  );

  const offerDesignIds: string[] = decodeUrlArrayParam(
    queryParams.get('offerDesignIds')
  );

  const createdAtFrom = queryParams.get('createdAtFrom') || '';
  const createdAtUntil = queryParams.get('createdAtUntil') || '';

  const priceBuckets: string[] = decodeUrlArrayParam(
    queryParams.get('priceBuckets')
  );

  return {
    page,
    rows,
    sortValue,
    direction,
    statuses,
    publisherPurchaseId,
    playerId,
    orderId,
    projects,
    receiptId,
    subscriptionId,
    transactionId,
    startDate,
    endDate,
    isFree,
    playerEmail,
    search,
    offerStatuses,
    offerSchedules,
    offerDesignIds,
    createdAtFrom,
    createdAtUntil,
    priceBuckets
  };
}
